import React from 'react';

import { createStackNavigator } from '@react-navigation/stack';
import { StackHeaderMode } from '@react-navigation/stack/src/types';

import { SCREEN } from 'router/screens';

import { COLOR } from 'utils/colors';

import PinSetupCreate from 'screens/PinSetup/PinSetupCreate';
import PinSetupIntroduction from 'screens/PinSetup/PinSetupIntroduction';
import PinSetupSuccess from 'screens/PinSetup/PinSetupSuccess';
import PinSetupUnsuccess from 'screens/PinSetup/PinSetupUnsuccess';

const Stack = createStackNavigator();
const stackScreenOptions = {
    headerShown: true,
    headerStyle: {
        shadowColor: 'transparent',
    },
    headerTitle: () => null,
    headerRight: () => null,
    headerLeft: () => null,
    cardStyle: {
        backgroundColor: COLOR.BLACK,
    },
    headerMode: 'screen' as StackHeaderMode,
    gestureEnabled: true,
};

export default function PinSetupNavigator() {
    return (
        <Stack.Navigator
            screenOptions={stackScreenOptions}
            initialRouteName={SCREEN.PIN_SETUP_INTRODUCTION}
        >
            <Stack.Screen
                name={SCREEN.PIN_SETUP_INTRODUCTION}
                component={PinSetupIntroduction}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name={SCREEN.PIN_SETUP_CREATE}
                component={PinSetupCreate}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name={SCREEN.PIN_SETUP_SUCCESS}
                component={PinSetupSuccess}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name={SCREEN.PIN_SETUP_UNSUCCESS}
                component={PinSetupUnsuccess}
                options={{ headerShown: false }}
            />
        </Stack.Navigator>
    );
}
